import { Filters, RadiusValue } from 'ha/types/SearchFilters';

export function getFilterTagsCount({
  types,
  furniture,
  bills,
  registration,
  rules,
  suitableFor,
  rooms,
  price,
  dates,
  recentlyAdded,
  propertySize,
  facilities,
  amenities,
  radius,
}: Filters): number {
  return (
    (types ? types.length : 0) +
    (furniture && furniture?.length > 0 ? 1 : 0) +
    (bills && bills.length > 0 ? 1 : 0) +
    (registration && registration.length > 0 ? 1 : 0) +
    (rules ? rules.length : 0) +
    (suitableFor ? suitableFor.length : 0) +
    (recentlyAdded ? 1 : 0) +
    (rooms ? rooms.bedroomCount.length : 0) +
    (price?.min || price?.max ? 1 : 0) +
    (dates?.startDate ? 1 : 0) +
    (propertySize?.sizeMin || propertySize?.sizeMax ? 1 : 0) +
    (facilities ? facilities.length : 0) +
    (amenities ? amenities.length : 0) +
    (radius && radius !== RadiusValue.DEFAULT ? 1 : 0)
  );
}
